/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { fetchWhitelist, addWhitelistEmail } from '../../services/WhitelistService';

export default function WhitelistPage() {
  const [email, setEmail] = useState('');
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const pageSize = 10;

  async function load(p = page) {
    setLoading(true);
    setError('');
    try {
      const result = await fetchWhitelist(p, pageSize);
      setList(result.items);
      setTotalPages(result.totalPages);
    } catch (e) {
      console.error(e);
      setError('Não foi possível obter a lista.');
    } finally {
      setLoading(false);
    }
  }

  async function onAdd(e) {
    e.preventDefault();
    const value = email.trim();
    if (!value) return;

    if (list.some(x => (x.email || '').toLowerCase() === value.toLowerCase())) {
      setError('E-mail já está cadastrado.');
      return;
    }

    setSaving(true);
    setError('');

    try {
      const created = await addWhitelistEmail(value);
      setList(prev => [{ email: created.email, code: created.code || '-' }, ...prev]);
      setEmail('');
      load();
    } catch (err) {
      console.error('Erro ao adicionar e-mail:', err);
      setError(err?.userMessage || 'Não foi possível adicionar o e-mail.');
    } finally {
      setSaving(false);
    }
  }

  useEffect(() => {
    load(page);
  }, [page]);

  function renderCodeCell(code) {
    if (!code || code === '-') return <i>-</i>;
    const text = String(code);
    const short = text.length > 30 ? text.slice(0, 30) + '…' : text;
    return <span title={text}>{short}</span>;
  }

  function nextPage() {
    if (page < totalPages) setPage(prev => prev + 1);
  }

  function prevPage() {
    if (page > 1) setPage(prev => prev - 1);
  }

  return (
    <section style={{ padding: 20 }}>
      <h1 style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 16 }}>
        Liberar e-mails para cadastro
      </h1>

      <form onSubmit={onAdd} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input
          type="email"
          required
          placeholder="email@dominio.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{
            flex: 1,
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid #e5e7eb',
            outline: 'none',
          }}
        />
        <button
          type="submit"
          disabled={saving}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            background: '#00E52E',
            color: '#000',
            fontWeight: 700,
            border: 0,
            cursor: 'pointer',
            opacity: saving ? 0.6 : 1,
          }}
        >
          {saving ? 'Enviando...' : 'Liberar'}
        </button>
      </form>

      {error && <div style={{ color: 'crimson', marginBottom: 12 }}>{error}</div>}

      {loading ? (
        <div>Carregando...</div>
      ) : (
        <>
          <div
            style={{
              width: '100%',
              maxHeight: '70vh',
              overflowY: 'auto',
              overflowX: 'auto',
              paddingRight: 4,
            }}
          >
            <table
              style={{
                width: '100%',
                minWidth: 520,
                borderCollapse: 'separate',
                borderSpacing: 0,
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: 'left',
                      padding: 12,
                      background: '#f8f9fb',
                      borderRadius: '8px 0 0 8px',
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                    }}
                  >
                    E-mail
                  </th>
                  <th
                    style={{
                      textAlign: 'left',
                      padding: 12,
                      background: '#f8f9fb',
                      borderRadius: '0 8px 8px 0',
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                    }}
                  >
                    Código
                  </th>
                </tr>
              </thead>

              <tbody>
                {list.length === 0 && (
                  <tr>
                    <td colSpan="2" style={{ padding: 16 }}>
                      Nenhum e-mail liberado.
                    </td>
                  </tr>
                )}

                {list.map((row, i) => (
                  <tr key={row.email || i}>
                    <td style={{ padding: 12, borderBottom: '1px solid #eee' }}>
                      <b>{row.email}</b>
                    </td>
                    <td style={{ padding: 12, borderBottom: '1px solid #eee' }}>
                      {renderCodeCell(row.code || '-')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, gap: 12 }}>
            <button
              onClick={prevPage}
              disabled={page === 1}
              style={{
                padding: '6px 12px',
                borderRadius: 6,
                border: '1px solid #ccc',
                cursor: page === 1 ? 'not-allowed' : 'pointer',
              }}
            >
              Anterior
            </button>

            <span>Página {page} de {totalPages}</span>

            <button
              onClick={nextPage}
              disabled={page === totalPages}
              style={{
                padding: '6px 12px',
                borderRadius: 6,
                border: '1px solid #ccc',
                cursor: page === totalPages ? 'not-allowed' : 'pointer',
              }}
            >
              Próxima
            </button>
          </div>
        </>
      )}
    </section>
  );
}







